import { render, staticRenderFns } from "./salesPayments.vue?vue&type=template&id=0cbdacfc"
import script from "./salesPayments.vue?vue&type=script&lang=js"
export * from "./salesPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports